export const messages = {
  page: {
    title: {
      id: 'inviteAuth.Title',
      defaultMessage: 'Authorization Statement',
    },
    instruction: {
      id: 'inviteAuth.Page.Instruction',
      defaultMessage: 'To continue, please read and accept the Authorization Statement below.',
    },
  },
  button: {
    agree: {
      id: 'inviteAuth.Button.Agree',
      defaultMessage: 'I Agree',
    },
    cancel: {
      id: 'inviteAuth.Button.Cancel',
      defaultMessage: 'Cancel',
    },
  },
};
